var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegramFilledWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.5 87.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.5 41.9l22.6 8.4 8.7 28.1c.6 1.8 2.8 2.5 4.2 1.3l12.6-10.3c1.3-1.1 3.2-1.1 4.6-.1l22.7 16.5c1.6 1.1 3.8.3 4.2-1.6l16.6-80c.4-2.1-1.6-3.8-3.6-3L2.5 36.9c-2.3.9-2.3 4.1 0 5zm29.9 3.9l44.1-27.2c.8-.5 1.6.6.9 1.2L41.1 53.7c-1.3 1.2-2.1 2.8-2.3 4.5l-1.2 9.2c-.2 1.2-1.9 1.3-2.2.2l-4.8-16.8c-.7-1.9.1-3.9 1.8-5z"
  })));
}

export default __webpack_public_path__ + "static/media/telegram_filled_white.7b7bc8ec9ab9ce2fdfbccb684c0d4f44.svg";
export { SvgTelegramFilledWhite as ReactComponent };